export default __webpack_public_path__ + "static/btv-b81d9339c74db7539168b31316ad5dc5.jpg";